module.exports = __webpack_public_path__ + "static/media/relationship_parent.e9aaa477.svg";